var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable max-lines */
import { Button, DrawerBody, DrawerFooter, DrawerHeader, FormController, FormLabel, Input, Typography, } from '@one-thd/sui-atomic-components';
import { Checkmark } from '@one-thd/sui-icons';
import { BrowserMultiFormatReader } from '@zxing/library';
import React, { Suspense, useEffect, useState, } from 'react';
import { useForm } from 'react-hook-form';
import { AddInstoreReceipt } from '../../../../api/oms/order-history';
import { inStoreErrors, scanReceiptErrors, } from '../../../../constants/receipt-error';
import { useCommonContext, useExperienceContext, } from '../../../../hooks/useContexts';
import { pushEventInfo } from '../../../../utils/analytics';
import { addHyphens, addSlash, makeInStoreRequestBody, } from '../../../../utils/order-history';
import { handleDisableBtn } from '../../../../utils/order-history/receipt-utils';
import { getMobileOSAndVersion } from '../../../../utils/shared/mobile';
import { AlertBanner } from '../../../shared/alert-banner/AlertBanner';
export var ReceiptScanner = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var closeDrawer = _a.closeDrawer, setAlertState = _a.setAlertState, setDrawerStepper = _a.setDrawerStepper, svocId = _a.svocId;
    var _h = useState(false), videoStream = _h[0], setVideoStream = _h[1];
    var _j = useState({
        receiptNumber: '',
        salesDate: '',
        preTaxAmount: '',
    }), inputError = _j[0], setInputError = _j[1];
    var _k = useState({
        error: false,
        tryAgain: false,
        successful: false,
    }), scanSettings = _k[0], setScanSettings = _k[1];
    var isMobile = useCommonContext().isMobile;
    var _l = useForm({
        mode: 'onBlur',
        defaultValues: {
            preTaxAmount: '',
            receiptNumber: '',
            salesDate: '',
            tryAgain404: false,
        },
    }), clearErrors = _l.clearErrors, errors = _l.formState.errors, handleSubmit = _l.handleSubmit, register = _l.register, reset = _l.reset, setError = _l.setError, setValue = _l.setValue, watch = _l.watch;
    var watchReceiptNumber = watch('receiptNumber');
    var watchSalesDate = watch('salesDate');
    var watchPreTaxAmount = watch('preTaxAmount');
    useEffect(function () {
        if (watchReceiptNumber.length === 16) {
            setInputError(function (prevState) { return (__assign(__assign({}, prevState), { receiptNumber: 'success' })); });
            clearErrors('receiptNumber');
        }
        if (watchReceiptNumber.length !== 16) {
            setInputError(function (prevState) { return (__assign(__assign({}, prevState), { receiptNumber: 'error' })); });
            setError('receiptNumber', { type: 'invalid', message: 'invalid entry' });
        }
    }, [watchReceiptNumber]);
    useEffect(function () {
        if (watchSalesDate.length === 8) {
            var tempYear = watchSalesDate.split('/');
            var tempDate = new Date("".concat(tempYear[2] < '20' ? '19' : '20').concat(tempYear[2], "/").concat(tempYear[0], "/").concat(tempYear[1]));
            if (Number.isNaN(tempDate === null || tempDate === void 0 ? void 0 : tempDate.getTime())) {
                setInputError(function (prevState) { return (__assign(__assign({}, prevState), { salesDate: 'error' })); });
                setError('salesDate', { type: 'invalid', message: 'invalid entry' });
                return;
            }
            setInputError(function (prevState) { return (__assign(__assign({}, prevState), { salesDate: 'success' })); });
            clearErrors('salesDate');
            return;
        }
        if (watchSalesDate.length !== 8) {
            setInputError(function (prevState) { return (__assign(__assign({}, prevState), { salesDate: 'error' })); });
            setError('salesDate', { type: 'invalid', message: 'invalid entry' });
        }
    }, [watchSalesDate]);
    useEffect(function () {
        if (watchPreTaxAmount.length > 3 && (watchPreTaxAmount === null || watchPreTaxAmount === void 0 ? void 0 : watchPreTaxAmount.at(-3)) === '.') {
            setInputError(function (prevState) { return (__assign(__assign({}, prevState), { preTaxAmount: 'success' })); });
            clearErrors('preTaxAmount');
            return;
        }
        if (inputError.preTaxAmount === 'success' &&
            (watchPreTaxAmount.length < 3 || (watchPreTaxAmount === null || watchPreTaxAmount === void 0 ? void 0 : watchPreTaxAmount.at(-3)) !== '.')) {
            setInputError(function (prevState) { return (__assign(__assign({}, prevState), { preTaxAmount: 'error' })); });
            setError('preTaxAmount', { type: 'invalid', message: 'invalid entry' });
        }
    }, [watchPreTaxAmount]);
    useEffect(function () {
        var timeoutId = setTimeout(function () {
            setScanSettings(function (prevState) { return (__assign(__assign({}, prevState), { error: true })); });
            setVideoStream(false);
        }, 10000);
        return function () { return clearTimeout(timeoutId); };
    }, [scanSettings.tryAgain]);
    var onFormSubmit = function (_a) {
        var preTaxAmount = _a.preTaxAmount, receiptNumber = _a.receiptNumber, salesDate = _a.salesDate;
        return __awaiter(void 0, void 0, void 0, function () {
            var request, response, status_1, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        clearErrors();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        request = null;
                        if (!(preTaxAmount && receiptNumber && salesDate && svocId)) return [3 /*break*/, 3];
                        request = makeInStoreRequestBody(svocId, receiptNumber, salesDate, preTaxAmount);
                        return [4 /*yield*/, AddInstoreReceipt(request)];
                    case 2:
                        response = _b.sent();
                        status_1 = response ? response.status : null;
                        if (status_1 === null) {
                            setError('tryAgain404', {
                                type: 'failed',
                                message: 'failed request',
                            });
                            return [2 /*return*/];
                        }
                        pushEventInfo({
                            category: { primaryCategory: 'button submission' },
                            eventInfo: { eventName: 'my account settings' },
                            myAccount: {
                                settings: 'add receipt: scan receipt: receipt add successful',
                            },
                        });
                        setAlertState({
                            alertMessage: "You've successfully added an in-store receipt to your account. View Receipt ".concat(receiptNumber),
                            status: 'success',
                        });
                        closeDrawer();
                        reset();
                        return [2 /*return*/];
                    case 3:
                        setError('tryAgain404', { type: 'failed', message: 'failed request' });
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _b.sent();
                        setError('tryAgain404', {
                            type: 'failed',
                            message: 'failed request',
                        });
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    var BarcodeScanner = function (_a) {
        var setScannerText = _a.setScannerText;
        var _b = useState(''), barcodeText = _b[0], setBarcodeText = _b[1];
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        var _c = useState(null), _barcodeError = _c[0], setBarcodeError = _c[1];
        var videoId = 'video';
        useEffect(function () {
            setVideoStream(true);
            var codeReader = new BrowserMultiFormatReader();
            if (navigator.mediaDevices) {
                codeReader
                    .listVideoInputDevices()
                    .then(function () {
                    codeReader
                        .decodeOnceFromVideoDevice(undefined, videoId)
                        .then(function (result) {
                        if (result) {
                            setBarcodeText(result.getText());
                        }
                    })
                        .catch(function (err) {
                        // eslint-disable-next-line no-console
                        console.log(err);
                        if (err) {
                            setBarcodeError(err);
                        }
                    });
                })
                    .catch(function (err) {
                    // eslint-disable-next-line no-console
                    console.log(err);
                });
            }
            else {
                setBarcodeError('Camera permissions denied');
            }
        }, []);
        useEffect(function () {
            if (barcodeText !== '') {
                if (setScannerText)
                    setScannerText(barcodeText);
            }
        }, [barcodeText]);
        return (React.createElement("div", { className: "sui-w-full sui-overflow-hidden sui-relative", style: { paddingTop: '100%' }, "data-testid": "receipt-barcode-scanner" },
            React.createElement("video", { id: videoId, className: "sui-top-0 sui-left-0 sui-w-full sui-h-full sui-block sui-overflow-hidden sui-absolute", muted: true })));
    };
    var renderScanner = function () {
        if (typeof window === 'undefined')
            return null;
        return (React.createElement(Suspense, { fallback: React.createElement("div", null) },
            React.createElement(BarcodeScanner, { onResult: function (_err, result) {
                    if (result) {
                        pushEventInfo({
                            category: { primaryCategory: 'button submission' },
                            eventInfo: { eventName: 'my account settings' },
                            myAccount: {
                                settings: 'add receipt: scan receipt: barcode scan successful',
                            },
                        });
                        handleScannerData(result);
                    }
                }, setError: scanSettings.error, setScannerText: handleScannerData, stopStream: scanSettings.error || videoStream === false })));
    };
    var calculateCheckDigit = function (registerNumber, transactionId) {
        var value = "0".concat(registerNumber).concat(transactionId, "0");
        // accept only digits, dashes or spaces
        if (/[^0-9-\s]+/.test(value))
            return '';
        // The Luhn Algorithm to calculate the check digit
        var checkDigit = 0;
        var digit = 0;
        var isEven = false;
        value = value.replace(/\D/g, '');
        for (var n = value.length - 1; n >= 0; n -= 1) {
            digit = parseInt(value.charAt(n), 10); // Ensure digit is a number
            if (isEven) {
                digit *= 2;
                if (digit > 9) {
                    digit -= 9;
                }
            }
            checkDigit += digit;
            isEven = !isEven;
        }
        checkDigit %= 10;
        if (checkDigit !== 0)
            checkDigit = 10 - checkDigit;
        return checkDigit.toString();
    };
    var handleScannerData = function (textResult) {
        var scannedText = textResult;
        setScanSettings(function (prevState) { return (__assign(__assign({}, prevState), { successful: true })); });
        var salesDate = scannedText.slice(0, 4) + 2 + scannedText.charAt(4);
        /**
         * Constants for the receipt number
         */
        var storeNumber = scannedText.slice(11, 15);
        var registerNumber = scannedText.slice(5, 7).padStart(5, '0');
        var transactionId = scannedText.slice(7, 11);
        var checkDigit = calculateCheckDigit(registerNumber, transactionId);
        var receiptNumber = storeNumber + registerNumber + transactionId + checkDigit;
        setValue('receiptNumber', addHyphens(receiptNumber.toUpperCase()));
        setValue('salesDate', addSlash(salesDate));
    };
    var isConsumerApp = useExperienceContext().isConsumerApp;
    var appInfo = getMobileOSAndVersion();
    // TODO: Remove this flag and UI after validation has happened.
    var androidScannerOfflineFlag = isConsumerApp && ['Android', 'android'].includes(appInfo.os);
    if (androidScannerOfflineFlag) {
        return (React.createElement(React.Fragment, null,
            React.createElement(DrawerHeader, { onClose: closeDrawer },
                React.createElement(Typography, { variant: "h4" }, "Scan Receipt")),
            React.createElement(DrawerBody, null,
                React.createElement(AlertBanner, { status: "error" }, "Our scanner is currently down but we are working to fix it. Please try again later."))));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(DrawerHeader, { onClose: closeDrawer },
            React.createElement(Typography, { variant: "h4" }, "Scan Receipt")),
        scanSettings.successful ? (React.createElement(React.Fragment, null,
            React.createElement(DrawerBody, { style: { height: isMobile ? '65vh' : '' } },
                React.createElement("div", { className: "sui-flex sui-gap-3 sui-items-center" },
                    React.createElement(Typography, { variant: "body-base" }, "Barcode Scan Successful"),
                    React.createElement(Checkmark, { size: "small", color: "success" })),
                React.createElement(FormController, { className: "sui-mt-6", fullWidth: true, status: inputError.receiptNumber || ((errors === null || errors === void 0 ? void 0 : errors.receiptNumber) && 'error') },
                    React.createElement(FormLabel, { htmlFor: "receiptNumber" },
                        "Receipt Number",
                        React.createElement("sup", null, "*")),
                    React.createElement(Input, __assign({ "aria-describedby": "receiptNumber-input", fullWidth: true, id: "receiptNumber", inputProps: {
                            maxLength: 16,
                        } }, register('receiptNumber', {
                        required: true,
                        minLength: 15,
                        onChange: function (event) {
                            return setValue('receiptNumber', addHyphens(event.target.value.toUpperCase()));
                        },
                        onBlur: function (event) {
                            return setValue('receiptNumber', addHyphens(event.target.value.toUpperCase()));
                        },
                    }), { placeholder: "XXXX-XXXXX-XXXXX" })),
                    (inputError.receiptNumber === 'error' ||
                        errors.receiptNumber) && (React.createElement(Typography, { variant: "body-xs", color: "danger" },
                        ((_b = errors === null || errors === void 0 ? void 0 : errors.receiptNumber) === null || _b === void 0 ? void 0 : _b.type) === 'tryAgain' &&
                            inStoreErrors.receiptNumberNotFound,
                        (['required', 'minLength', 'invalid', 'pattern'].includes((_d = (_c = errors === null || errors === void 0 ? void 0 : errors.receiptNumber) === null || _c === void 0 ? void 0 : _c.type) !== null && _d !== void 0 ? _d : 'invalid') ||
                            inputError.receiptNumber === 'error') &&
                            inStoreErrors.receiptNumberInvalidFormat))),
                React.createElement(FormController, { className: "sui-mt-6", fullWidth: true, status: inputError.salesDate || ((errors === null || errors === void 0 ? void 0 : errors.salesDate) && 'error') },
                    React.createElement(FormLabel, { htmlFor: "salesDate" },
                        "Purchase Date",
                        React.createElement("sup", null, "*")),
                    React.createElement(Input, __assign({ "aria-describedby": "salesDate-input", fullWidth: true, id: "salesDate", inputProps: {
                            maxLength: 8,
                        } }, register('salesDate', {
                        required: true,
                        minLength: 7,
                        pattern: /^(\d{2})\/(\d{2})\/(\d{2})$/,
                        onChange: function (event) {
                            return setValue('salesDate', addSlash(event.target.value));
                        },
                        onBlur: function (event) {
                            return setValue('salesDate', addSlash(event.target.value));
                        },
                    }), { placeholder: "MM/DD/YY" })),
                    (inputError.salesDate === 'error' || errors.salesDate) && (React.createElement(Typography, { variant: "body-xs", color: "danger" },
                        ((_e = errors === null || errors === void 0 ? void 0 : errors.salesDate) === null || _e === void 0 ? void 0 : _e.type) === 'tryAgain' &&
                            inStoreErrors.salesDateNotFound,
                        (['required', 'minLength', 'invalid', 'pattern'].includes((_g = (_f = errors === null || errors === void 0 ? void 0 : errors.salesDate) === null || _f === void 0 ? void 0 : _f.type) !== null && _g !== void 0 ? _g : 'invalid') ||
                            inputError.salesDate === 'error') &&
                            inStoreErrors.salesDateInvalidFormat))),
                React.createElement(FormController, { className: "sui-my-4", fullWidth: true, status: inputError.preTaxAmount || ((errors === null || errors === void 0 ? void 0 : errors.preTaxAmount) && 'error') },
                    React.createElement(FormLabel, { htmlFor: "preTaxAmount" },
                        "Pre-Tax Amount",
                        React.createElement("sup", null, "*")),
                    React.createElement(Input, __assign({ "aria-describedby": "preTaxAmount-input", fullWidth: true, id: "preTaxAmount" }, register('preTaxAmount', {
                        required: true,
                        minLength: 3,
                        pattern: /(\d+\.\d{1,2})/,
                        onChange: function (event) {
                            return setValue('preTaxAmount', event.target.value);
                        },
                        onBlur: function (event) {
                            return setValue('preTaxAmount', event.target.value);
                        },
                    }), { placeholder: "$" })),
                    (inputError.preTaxAmount === 'error' || errors.preTaxAmount) && (React.createElement(Typography, { variant: "body-xs", color: "danger" }, scanReceiptErrors.preTaxAmountInvalidFormat)),
                    errors.tryAgain404 && (React.createElement("div", { className: "sui-mt-6" },
                        React.createElement(Typography, { color: "danger" }, inStoreErrors.api404Error))))))) : (React.createElement(React.Fragment, null,
            React.createElement(DrawerBody, { style: { height: isMobile ? '65vh' : '' } },
                React.createElement("div", { className: "sui-pb-4" },
                    React.createElement(Typography, { variant: "body-base" }, "Please position your camera to ensure that the barcode fills the entire screen and is centered.")),
                scanSettings.error ? (React.createElement("div", { style: {
                        width: '100%',
                        height: '221px',
                        backgroundColor: '#000',
                    } })) : (React.createElement("div", null, renderScanner())),
                scanSettings.error && (React.createElement("div", { className: " sui-pt-4" },
                    React.createElement(Typography, { variant: "body-base", weight: "bold" }, "We couldn't quite read that"),
                    React.createElement(Typography, { variant: "body-base" }, "Hold the camera steady and try scanning again, or you can manually type in your receipt details.")))))),
        React.createElement(DrawerFooter, { position: "end" },
            React.createElement("div", { className: "card-fix sui-container sui-flex sui-flex-col sui-gap-3" },
                React.createElement(Button, { onClick: scanSettings.successful
                        ? handleSubmit(onFormSubmit)
                        : function () {
                            if (setDrawerStepper)
                                setDrawerStepper(1);
                        }, disabled: scanSettings.successful
                        ? handleDisableBtn(errors, inputError)
                        : !scanSettings.error, variant: "primary" }, scanSettings.successful ? 'OK' : 'Manually Add Receipt'),
                React.createElement(Button, { onClick: scanSettings.successful
                        ? closeDrawer
                        : function () {
                            setScanSettings(function (prevState) { return (__assign(__assign({}, prevState), { error: false, tryAgain: true })); });
                        }, disabled: !scanSettings.error, variant: "secondary" }, scanSettings.successful ? 'Cancel' : 'Scan Again')))));
};
